class CustomCursor extends HTMLElement {
  constructor() {
    super();
    this.target = null;
    this.lastX = 0;
    this.lastY = 0;

    this.position = e => {
      const rect = this.target.getBoundingClientRect();
      this.lastX = e.clientX - rect.left;
      this.lastY = e.clientY - rect.top;
      this.style.transform = `translate3d(${this.lastX}px,${this.lastY}px,0)`;
    };

    this.show = () => this.style.opacity = '1';
    this.hide = () => this.style.opacity = '0';

    this.disable = () => this.style.visibility = 'hidden';
    this.enable = () => {
      this.position({
        clientX: -10000,
        clientY: -10000
      });
      this.style.visibility = 'visible';
    }

    this.clickEffect = () => {
      this.classList.add('is-active');
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.classList.remove('is-active');
      }, 150);
    };
  }

  connectedCallback() {
    const selector = this.dataset.target;
    if (!selector) return;

    if (selector.includes('#')) {
      this.target = document.querySelector(selector);
    } else {
      this.target = this.closest(selector);
    }
    if (!this.target) return;

    this.target.addEventListener('mousemove', this.position);
    this.target.addEventListener('mouseenter', this.show);
    this.target.addEventListener('mouseleave', this.hide);
    this.target.addEventListener('click', this.clickEffect);
  }

  disconnectedCallback() {
    if (!this.target) return;
    this.target.removeEventListener('mousemove', this.position);
    this.target.removeEventListener('mouseenter', this.show);
    this.target.removeEventListener('mouseleave', this.hide);
    this.target.removeEventListener('click', this.clickEffect);
  }
}

if (!customElements.get('custom-cursor')) {
  customElements.define('custom-cursor', CustomCursor);
}
